import { ImageCropUUID } from './imageCropsTypes';

export class ImageCropCache {
  static imageCropDropzoneHelper() {
    return 'image-crops-dropzone-helper';
  }

  static downloadFile(uuid: ImageCropUUID) {
    return `image-crop-${uuid}-file-download`;
  }

  static downloadUrls(uuid: ImageCropUUID) {
    return `image-crop-${uuid}-download-urls`;
  }
}
